<template>
  <div v-if="show">
    <b-popover triggers="hover" parent="#map" target="mining-info" placement="left" :content="$t('map.layers.mining.info')"></b-popover>
    <b-popover triggers="hover" parent="#map" target="logging-info" placement="left" :content="$t('map.layers.logging.info')"></b-popover>
    <b-popover triggers="hover" parent="#map" target="protected-areas-info" placement="left" :content="$t('map.layers.protected-areas.info')"></b-popover>
    <b-popover triggers="hover" parent="#map" target="agriculture-info" placement="left" :content="$t('map.layers.agriculture.info')"></b-popover>
  </div>
</template>

<script>
export default {
    data(){
        return {
            show: false
        }
    },
    created() {
        let _vm = this;
        _vm.$root.$on("map-init", () => {
            _vm.show = true;
        });
    }
}
</script>

<style>

</style>
